import axios from '@/plugins/axios'
import { DropdownClient, FilterClient, FlowListClient, KPIClient, PermissionClient, RoleClient, UserClient } from './Connector'

export const dropdownClient: DropdownClient = new DropdownClient(process.env.VUE_APP_BASE_API_URL, axios)
export const filterClient: FilterClient = new FilterClient(process.env.VUE_APP_BASE_API_URL, axios)
export const flowListClient: FlowListClient = new FlowListClient(process.env.VUE_APP_BASE_API_URL, axios)
export const kpiClient: KPIClient = new KPIClient(process.env.VUE_APP_BASE_API_URL, axios)
export const roleClient: RoleClient = new RoleClient(process.env.VUE_APP_BASE_API_URL, axios)
export const userClient: UserClient = new UserClient(process.env.VUE_APP_BASE_API_URL, axios)
export const permissionClient: PermissionClient = new PermissionClient(process.env.VUE_APP_BASE_API_URL, axios)
